module.exports = __webpack_public_path__ + "static/media/3d_print.9bde0ad1.jpg";